import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.14648 7.07361C7.31728 6.54732 7.63015 6.07896 8.05078 5.71948C8.47141 5.36001 8.9838 5.12378 9.53027 5.03708C10.0768 4.95038 10.6362 5.0164 11.1475 5.22803C11.6587 5.43966 12.1014 5.78875 12.4268 6.23633C12.7521 6.68391 12.9469 7.21256 12.9904 7.76416C13.0339 8.31576 12.9238 8.86879 12.6727 9.36182C12.4215 9.85484 12.0394 10.2685 11.5676 10.5576C11.0958 10.8467 10.5533 10.9998 10 10.9998V12.0002M10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19ZM10.0498 15V15.1L9.9502 15.1002V15H10.0498Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCircleHelp;
